import { ComboItem } from "../../../../model/common/ComboItem";
import { EmailTemplateEditIn, EmailTemplateEditOut, EmailTemplateListOut, RemitenteEditIn, RemitenteEditOut, RemitenteListOut } from "../../../../model/notificaciones";
import ServiceBase from "../../../servicebase";
import { ControllerEntityService } from "./ControllerEntityService";

export class NotificacionesService extends ServiceBase {
  private controller: string = 'notificaciones';

  EmailTemplate = () => new ControllerEntityService<EmailTemplateEditOut, EmailTemplateEditIn, EmailTemplateListOut, ComboItem, { id?: number, codigo?: string, clienteNombre?: string; idsClientes?: number[]; tipo?: string; nombre?: string, asunto?: string }, {}>(this.urlAPI, this.controller, "EmailTemplate");

  Remitente = () => new ControllerEntityService<RemitenteEditOut, RemitenteEditIn, RemitenteListOut, ComboItem, { id?: number, codigo?: string, clienteNombre?: string; idsClientes?: number[]; tipo?: string; nombre?: string, correo?: string }, {}>(this.urlAPI, this.controller, "Remitente");
}

